import { initializeFirebase } from './init';

export const Firebase = {
    initializeFirebase
};
